import React, { Component } from 'react'
import { Table, Button, Modal, Input, Icon, Popover, Select, AutoComplete, Radio, Upload, Form, Row, Col, Pagination, Spin } from 'antd'
import { app, api, config } from '../../../app'
import Editor from '../../teamApplication/PreparatoryTeamApplicationDirectory/UploadInformationModal/Editor'
import WhiteList from '../../sign/WhiteList'
const Option = Select.Option

const RadioGroup = Radio.Group
const Search = Input.Search
const FormItem = Form.Item



class ReTeamApplicationAuditCom extends Component {
    // 组件内部
    constructor(props) {
        super(props)

        this.state = {
            data: [],
            total: 0,
            page: 1,
            EditorFlag: false,
            modalInfo: [
            ],
            status: 0,
            searchValue: '',
            searchType: 'teamname',


            examineRadio: '',
            examineModel: false,

            okUploadFieldImgList: [],
            okUploadEquipmentImgList: [],
            noUploadFieldImgList: [],
            noUploadEquipmentImgList: [],

            reasonTitle: '',


            // 白名单弹窗
            WhiteListModal: false,
            WhiteInput: '',
            whiteInfoList: [],


            // 等级权限
            audit_level: 0,
            examineInfo: [],


            addWhiteListModal: false,
            player_search_type: 'searchform_name',
            searcWhitehList: [],
            object_indexno: '',


            twoReasonTitle: '',   //二级审核通过评价
            twoNoReasonTitle: '', //不通过评价


            imgModal: false, //图片预览弹窗
            showMoadlImg: '',//正在预览的图片
            showImgState: '',

            imgType: undefined,   //当前查看的图片是否是审核的
            up_loading: false
        }
        // this.getAuditList()

    }

    componentDidMount() {
        this.dataSource()

    }




    getAuditList = () => {
        app.post(api.PrepAuditlists, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            status: this.state.status,
            page: 1
        }).then(res => {
            if (res.flag == 1) {
                // console.log(res)
                this.setState({
                    data: res.data,
                    total: parseInt(res.total || 0)
                })
            } else {

                app.alert(res.msg, 'error', '45%')
            }
        })
    }


    Details = (e) => {
        this.setState({
            audit_level: e.audit_level
        })
        app.post(api.TeamPrepAuditDetail, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            prep_id: e.id
        }).then(res => {
            // console.log(res)
            this.setState({
                modalInfo: e,
                examineInfo: res.data,
                audit_level: res.data.audit_level
            }, () => {
                app.setData('examineInfo', res.data)
                this.setState({
                    EditorFlag: true,
                }, () => {

                })
            })
        })
        // audit_level
    }

    //跳转至审核
    goExamine = (e) => {
        this.setState({
            audit_level: e.audit_level
        })

        app.post(api.TeamPrepAuditDetail, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            prep_id: e.id
        }).then(res => {
            // console.log(res)
            this.setState({
                modalInfo: e,
                examineModel: true,
                examineInfo: res.data,
                examineRadio: ''
            })
            if (this.state.EditorFlag) {
                this.setState({
                    EditorFlag: false
                })
            }
        })


    }

    Editor = (e) => {

    }


    // 关闭弹窗
    EditorModalCencel = () => {
        this.setState({
            EditorFlag: false
        })
    }

    choiceOption = (e) => {
        // console.log(e)
        if (e == 1) {
            app.post(api.PrepAuditlists, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                status: 0,
                page: 1
            }).then(res => {
                // console.log(res)
                this.setState({
                    data: res.data,
                    status: 0,
                    total: parseInt(res.total || 0)
                })
            })
        } else {
            app.post(api.PrepAuditlists, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                status: 1,
                page: 1
            }).then(res => {
                // console.log(res)
                this.setState({
                    data: res.data,
                    status: 1,
                    total: parseInt(res.total || 0)

                })
            })
        }
    }


    choiceOption2 = (e) => {
        this.setState({
            searchType: e
        })
    }

    getInputValue = (e) => {
        // console.log(e)
        this.setState({
            searchValue: e
        })

    }

    clickSearch = () => {
        this.setState({
            page: 1
        })
        const { searchType, searchValue } = this.state;
        app.post(api.PrepAuditlists, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            status: this.state.status,
            search_type: this.state.searchType,
            search_val: searchValue,
            page: 1
        }).then(res => {
            this.setState({
                data: res.data,
                total: parseInt(res.total || 0)
            })
        })
    }






    downExamine = () => {
        this.setState({
            examineModel: false,
            okUploadFieldImgList: [],
            okUploadEquipmentImgList: [],
            noUploadFieldImgList: [],
            noUploadEquipmentImgList: [],
            reasonTitle: '',
        })
    }

    examineRadio = (e) => {
        this.setState({
            examineRadio: e.target.value
        })
    }

    // 通过modal上传场地图片
    okUploadFieldImg = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({
                up_loading: true
            })
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                app.alert(res.msg, 'success', '45%')
                const { okUploadFieldImgList } = this.state;
                okUploadFieldImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.setState({
                    okUploadFieldImgList
                }, () => {
                    this.setState({
                        up_loading: false
                    })
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }
    // 通过modal上传装备图片
    okUploadEquipmentImg = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({
                up_loading: true
            })
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                app.alert(res.msg, 'success', '45%')
                const { okUploadEquipmentImgList } = this.state;
                okUploadEquipmentImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.setState({
                    okUploadEquipmentImgList
                }, () => {
                    this.setState({
                        up_loading: false
                    })
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }



    // 不通过modal上传场地图片
    noUploadFieldImg = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({
                up_loading: true
            })
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                app.alert(res.msg, 'success', '45%')
                const { noUploadFieldImgList } = this.state;
                noUploadFieldImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.setState({
                    noUploadFieldImgList
                }, () => {
                    this.setState({
                        up_loading: false
                    })
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }
    // 不通过modal上传装备图片
    noUploadEquipmentImg = (info) => {
        if (info.file.status === 'uploading') {
            this.setState({
                up_loading: true
            })
            return
        }
        if (info.file.status === 'done') {
            const res = info.file.response
            if (res.flag === 1) {
                app.alert(res.msg, 'success', '45%')
                const { noUploadEquipmentImgList } = this.state;
                noUploadEquipmentImgList.push(res.data.url)
                // 当上传图片完成后将返回的图片放到本地以备用户预览
                this.setState({
                    noUploadEquipmentImgList
                }, () => {
                    this.setState({
                        up_loading: false
                    })
                })
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        }
    }


    getReasonTitle = (e) => {
        // const  reasonTitle  = this.state.reasonTitle
        // reasonTitle = 
        this.setState({
            [e.target.name]: e.target.value.trim()
        })
    }

    // 通过提交
    okUpload = () => {
        if (this.state.okUploadFieldImgList.length < 1 && this.state.examineInfo.audit_level != 1) {
            app.alert("场地核查情况照片未上传", 'error', '45%')
            return
        }
        if (this.state.okUploadEquipmentImgList.length < 1 && this.state.examineInfo.audit_level != 1) {
            app.alert("装备核查情况照片未上传", 'error', '45%')
            return
        }


        // console.log(this.state)

        let okUploadFieldImgList = JSON.stringify(this.state.okUploadFieldImgList.join(';;;'))
        let okUploadEquipmentImgList = JSON.stringify(this.state.okUploadEquipmentImgList.join(';;;'))

        // /TeamPrepAudit/auditSecondary
        if (this.state.examineInfo.one_audit_title == "审核通过") {
            // 2
            if (this.state.twoReasonTitle == '') {
                app.alert("通过评价不能为空", 'error', '45%')
                return
            }
            app.post(api.TeamPrepAuditAuditSecondary, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                prep_id: this.state.modalInfo.id,
                status: 1,
                evaluate: this.state.twoReasonTitle
            }).then(res => {
                if (res.flag == 1) {
                    app.alert(res.msg, 'success', '45%')
                    this.setState({
                        examineModel: false,
                        okUploadFieldImgList: [],
                        okUploadEquipmentImgList: [],
                        twoReasonTitle: ''
                    })
                    this.getAuditList()

                } else {
                    app.alert(res.msg, 'error', '45%')
                    this.setState({
                        examineModel: false
                    })
                }
            })
            // TeamPrepAuditAuditSecondary
        } else {
            // 1级审核
            app.post(api.TeamPrepAuditAuditFirst, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                prep_id: this.state.modalInfo.id,
                status: 1,
                place_img: okUploadFieldImgList,
                mall_img: okUploadEquipmentImgList
            }).then(res => {
                if (res.flag == 1) {
                    app.alert(res.msg, 'success', '45%')
                    this.setState({
                        examineModel: false,
                        okUploadFieldImgList: [],
                        okUploadEquipmentImgList: []
                    })
                    this.getAuditList()

                } else {
                    app.alert(res.msg, 'error', '45%')
                    this.setState({
                        examineModel: false
                    })
                }
            })
        }

    }


    // 不通过提交
    noUpload = () => {
        // 2级判断
        if (this.state.noUploadFieldImgList.length < 1 && this.state.examineInfo.audit_level != 1 && this.state.examineInfo.one_audit == 1) {
            app.alert("场地核查情况照片未上传", 'error', '45%')
            return
        }
        if (this.state.noUploadEquipmentImgList.length < 1 && this.state.examineInfo.audit_level != 1 && this.state.examineInfo.one_audit == 1) {
            app.alert("装备核查情况照片未上传", 'error', '45%')
            return
        }
        let noUploadFieldImgList = JSON.stringify(this.state.noUploadFieldImgList.join(';;;'))
        let noUploadEquipmentImgList = JSON.stringify(this.state.noUploadEquipmentImgList.join(';;;'))
        if (this.state.twoNoReasonTitle == '' && this.state.examineInfo.audit_level != 1 && this.state.examineInfo.one_audit == 1) {
            app.alert('评价不能为空', 'error', '45%')
            return
        }
        if (this.state.reasonTitle == '') {
            app.alert('不通过原因不能为空', 'error', '45%')
            return
        }

        
        
        if (this.state.examineInfo.audit_level == 1) {
            if (this.state.twoNoReasonTitle == '') {
                app.alert("通过评价不能为空", 'error', '45%')
                return
            }
            app.post(api.TeamPrepAuditAuditSecondary, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                prep_id: this.state.modalInfo.id,
                status: 2,
                detail: this.state.reasonTitle,
                evaluate: this.state.twoNoReasonTitle
            }).then(res => {
                // console.log(res)
                if (res.flag == 1) {
                    app.alert(res.msg, 'success', '45%')
                    this.setState({
                        examineModel: false,
                        noUploadFieldImgList: [],
                        noUploadEquipmentImgList: [],
                        reasonTitle: '',
                        twoNoReasonTitle: '',
                        status: 0
                    })
                    this.getAuditList()

                } else {
                    app.alert(res.msg, 'error', '45%')
                    this.setState({
                        examineModel: false
                    })
                }
            })
        } else {
            
            app.post(api.TeamPrepAuditAuditFirst, {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                prep_id: this.state.modalInfo.id,
                status: 2,
                place_img: noUploadFieldImgList,
                mall_img: noUploadEquipmentImgList,
                detail: this.state.reasonTitle
            }).then(res => {
                // console.log(res)
                if (res.flag == 1) {
                    app.alert(res.msg, 'success', '45%')
                    this.setState({
                        examineModel: false,
                        noUploadFieldImgList: [],
                        noUploadEquipmentImgList: [],
                        reasonTitle: '',
                        status: 0
                    })
                    this.getAuditList()

                } else {
                    app.alert(res.msg, 'error', '45%')
                    this.setState({
                        examineModel: false
                    })
                }
            })
        }

    }


    // 打开添加白名单弹窗
    openWhiteListModal = () => {
        this.setState({
            WhiteListModal: true,
        })
        this.getWhiteList()

    }

    closeWhiteList = () => {
        this.setState({
            WhiteListModal: false,
        })
    }

    getWhiteList = () => {
        app.post(api.TeamPrepAuditAllowLists, {
            indexno: app.getData('indexno'),
            account: app.getData('account')
        }).then(res => {
            // console.log(res)
            this.setState({
                WhiteListModal: true,
                whiteInfoList: res.data
            })
        })
    }

    // 白名单input
    getInput = (e) => {
        this.setState({
            WhiteInput: e.target.value
        })

    }

    // 白名单搜索
    onSearch = () => {
        const { WhiteInput } = this.state;
        app.post(api.TeamPrepAuditAllowLists, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            search_val: WhiteInput
        }).then(res => {
            // console.log(res)
            this.setState({
                WhiteListModal: true,
                whiteInfoList: res.data
            })
        })
    }


    // 删除白名单
    deleWhite = (e) => {
        app.post(api.TeamPrepAuditAllowDelete, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            id: e.id
        }).then(res => {
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')

                this.getWhiteList()  //重新请求白名单列表
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        })
    }

    add = (e,option) => {
        console.log(e)
        console.log(option)
        let star = option.props.children.indexOf('（')
        let bsrno = ''
        if(star != -1){
            bsrno = option.props.children.substring(star + 1 ,option.props.children.length-1)
        }else{
            bsrno = option.props.children
        }
        console.log(option.props.children)
        
        this.setState({
            object_indexno: e,
            object_name:option.props.children
        })
        if(e == '' || option.props.children == ''){
            return
        }
        const params = {
            search_type: this.state.player_search_type,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        if(this.state.player_search_type == 'searchform_name'){
            params.search_val = option.props.children
            // search_val: e,
        }else{
            params.search_val = bsrno

        }
        // if(params.search_val == ''){
        //     return
        // }
        app.post(api.ReportsSearchPlayer, params).then(res => {
            let searcWhitehList = []

            if (this.state.player_search_type == 'searchform_name') {
                res.data.forEach(i => {
                    let b = {}
                    b.value = i.indexno,
                        b.text = i.vname
                    searcWhitehList.push(b)
                })
            } else {
                res.data.forEach(i => {
                    let b = {}
                    b.value = i.indexno,
                        b.text = i.vname + '（' + i.bsrno + '）'
                    searcWhitehList.push(b)
                })
            }

            this.setState({
                searcWhitehList
            },()=>{
                console.log(this.state.searcWhitehList)
            })
        })
    }

    addWhite = () => {
        
        if(this.state.object_indexno == '' || this.state.searcWhitehList.length<1){
            return
        }
        app.post(api.TeamPrepAuditAllowAdd, {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            object_indexno: this.state.object_indexno
        }).then(res => {
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')

                this.getWhiteList()  //重新请求白名单列表
            } else {
                app.alert(res.msg, 'error', '45%')

            }
        })
    }

    addWhiteList = () => {
        this.setState({
            addWhiteListModal: true
        })
    }

    closeaddWhiteListModal = () => {
        this.setState({
            addWhiteListModal: false
        })
    }


    whiteSele = (e) => {
        // console.log(e)
        this.setState({
            player_search_type: e
        })
    }

    


    // 2级提交
    twoOkUpload = () => {

    }




    //点击图片预览
    clickImg = (i) => {
        this.setState({
            imgModal: true,
            showMoadlImg: i.target.getAttribute('data-img'),
            showImgState: i.target.getAttribute('data-state'),
            imgType: i.target.getAttribute('data-type')
        })
    };


    clickImgCencel = () => {
        //关闭图片预览
        this.setState({
            imgModal: false
        })
    }


    // 点击上一张
    lastImg = () => {
        // 当前查看的是审核的图片
        if (this.state.imgType != undefined) {
            // console.log(1213121)
            let { showImgState } = this.state;
            if (showImgState == 'fieldImg') {
                let { examineInfo, showMoadlImg } = this.state, index, imgList = examineInfo.place_img.split(';;;')   //获取上传的场地图片，创建变量index

                imgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == 0) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == 0) {
                    return
                } else {
                    showMoadlImg = imgList[index - 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
            //如果当前点击预览的是装备图片
            if (showImgState == 'quipmentImg') {
                let { examineInfo, showMoadlImg } = this.state, index, imgList = examineInfo.mall_img.split(';;;')   //获取上传的装备图片，创建变量index


                imgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == 0) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == 0) {
                    return
                } else {
                    showMoadlImg = imgList[index - 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
        }
        //将状态回复
        if (this.state.imgType != undefined) {
            this.setState({
                imgType: undefined
            }, () => {
                console.log(this.state.imgType)
                return
            })
        }

        //上传阶段
        if (this.state.examineRadio == 'OK') {
            //如果当前是处于同意通过状态，那么应该获取的是okup
            // console.log("当前是OK")
            let { showImgState } = this.state;
            //如果当前点击预览的是场地图片
            if (showImgState == 'fieldImg') {
                let { okUploadFieldImgList, showMoadlImg } = this.state, index   //获取上传的场地图片，创建变量index

                okUploadFieldImgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == 0) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == 0) {
                    return
                } else {
                    showMoadlImg = okUploadFieldImgList[index - 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
            //如果当前点击预览的是装备图片
            if (showImgState == 'quipmentImg') {
                let { okUploadEquipmentImgList, showMoadlImg } = this.state, index   //获取上传的装备图片，创建变量index

                okUploadEquipmentImgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == 0) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == 0) {
                    return
                } else {
                    showMoadlImg = okUploadEquipmentImgList[index - 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
            // 审核操作为 通过 的场地和装备图片操作end
        } else {
            // console.log("当前是no")
            let { showImgState } = this.state;
            //如果当前点击预览的是场地图片
            if (showImgState == 'fieldImg') {
                let { noUploadFieldImgList, showMoadlImg } = this.state, index   //获取上传的场地图片，创建变量index

                noUploadFieldImgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == 0) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == 0) {
                    return
                } else {
                    showMoadlImg = noUploadFieldImgList[index - 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
            //如果当前点击预览的是装备图片
            if (showImgState == 'quipmentImg') {

                let { noUploadEquipmentImgList, showMoadlImg } = this.state, index   //获取上传的装备图片，创建变量index

                noUploadEquipmentImgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == 0) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == 0) {
                    return
                } else {
                    showMoadlImg = noUploadEquipmentImgList[index - 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }

        }


    }

    // 点击下一张
    nextImg = () => {

        if (this.state.imgType != undefined) {
            // console.log(1213121)
            let { showImgState } = this.state;
            if (showImgState == 'fieldImg') {
                let { examineInfo, showMoadlImg } = this.state, index, imgList = examineInfo.place_img.split(';;;')   //获取上传的场地图片，创建变量index

                imgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == imgList.length - 1) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == imgList.length - 1) {
                    return
                } else {
                    showMoadlImg = imgList[index + 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
            //如果当前点击预览的是装备图片
            if (showImgState == 'quipmentImg') {
                let { examineInfo, showMoadlImg } = this.state, index, imgList = examineInfo.mall_img.split(';;;')   //获取上传的装备图片，创建变量index


                imgList.forEach((i, v) => {
                    if (i == showMoadlImg) {
                        if (v == imgList.length - 1) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == imgList.length - 1) {
                    return
                } else {
                    showMoadlImg = imgList[index + 1]
                    this.setState({
                        showMoadlImg
                    })
                }
            }
        }
        //将状态回复
        if (this.state.imgType != undefined) {
            this.setState({
                imgType: undefined
            }, () => {
                console.log(this.state.imgType)
                return
            })
        }

        if (this.state.examineRadio == 'OK') {
            //如果当前是处于同意通过状态，那么应该获取的是okup
            let { showImgState } = this.state;
            if (showImgState == 'fieldImg') { //如果当前点击预览的是场地图片
                let { okUploadFieldImgList, showMoadlImg } = this.state, index   //获取上传的场地图片，创建变量index
                okUploadFieldImgList.forEach((i, v) => {
                    //获取当前预览的图片在上传图片数组中的索引值
                    if (i == showMoadlImg) {
                        //判断当前预览的图片在数组中是否是唯一的一张或者是最后一张
                        if (v == okUploadFieldImgList.length - 1) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == okUploadFieldImgList.length - 1) {
                    return
                } else {
                    showMoadlImg = okUploadFieldImgList[index + 1]
                    this.setState({
                        showMoadlImg
                    })
                }

            } else {
                let { okUploadEquipmentImgList, showMoadlImg } = this.state, index   //获取上传的装备图片，创建变量index
                okUploadEquipmentImgList.forEach((i, v) => {
                    //获取当前预览的图片在上传图片数组中的索引值
                    if (i == showMoadlImg) {
                        //判断当前预览的图片在数组中是否是唯一的一张或者是最后一张
                        if (v == okUploadEquipmentImgList.length - 1) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == okUploadEquipmentImgList.length - 1) {
                    return
                } else {
                    showMoadlImg = okUploadEquipmentImgList[index + 1]
                    this.setState({
                        showMoadlImg
                    })
                }

            }

            // 审核操作为 通过 的场地和装备图片操作end
        } else {
            let { showImgState } = this.state;

            if (showImgState == 'fieldImg') { //如果当前点击预览的是场地图片
                let { noUploadFieldImgList, showMoadlImg } = this.state, index   //获取上传的场地图片，创建变量index
                noUploadFieldImgList.forEach((i, v) => {
                    //获取当前预览的图片在上传图片数组中的索引值
                    if (i == showMoadlImg) {
                        //判断当前预览的图片在数组中是否是唯一的一张或者是最后一张
                        if (v == noUploadFieldImgList.length - 1) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == noUploadFieldImgList.length - 1) {
                    return
                } else {
                    showMoadlImg = noUploadFieldImgList[index + 1]
                    this.setState({
                        showMoadlImg
                    })
                }

            } else {
                let { noUploadEquipmentImgList, showMoadlImg } = this.state, index   //获取上传的装备图片，创建变量index
                noUploadEquipmentImgList.forEach((i, v) => {
                    //获取当前预览的图片在上传图片数组中的索引值
                    if (i == showMoadlImg) {
                        //判断当前预览的图片在数组中是否是唯一的一张或者是最后一张
                        if (v == noUploadEquipmentImgList.length - 1) {
                            index = v
                            app.alert("没有更多图片了", 'error', '45%')
                            return
                        } else {
                            index = v
                        }
                    }
                })
                if (index == noUploadEquipmentImgList.length - 1) {
                    return
                } else {
                    showMoadlImg = noUploadEquipmentImgList[index + 1]
                    this.setState({
                        showMoadlImg
                    })
                }

            }

        }

    }


    deleImg = (i, showImgState) => {
        // console.log(showImgState)
        // console.log(i)
        // 判断当前审核状态是什么
        if (this.state.examineRadio == 'OK') {
            //判断当前点击删除的是哪组图片数组
            if (showImgState == 'fieldImg') {
                //如果当前点击删除的是场地图片
                let okUploadFieldImgList = this.state.okUploadFieldImgList;
                okUploadFieldImgList.splice(i, 1)
                this.setState({
                    okUploadFieldImgList
                })
            } else {
                //当前点击的是装备图片
                let okUploadEquipmentImgList = this.state.okUploadEquipmentImgList;
                okUploadEquipmentImgList.splice(i, 1)
                this.setState({
                    okUploadEquipmentImgList
                })
            }
        } else {
            //当前的是状态是不通过
            if (showImgState == 'fieldImg') {
                //如果当前点击删除的是场地图片
                let noUploadFieldImgList = this.state.noUploadFieldImgList;
                noUploadFieldImgList.splice(i, 1)
                this.setState({
                    noUploadFieldImgList
                })
            } else {
                //当前点击的是装备图片
                let noUploadEquipmentImgList = this.state.noUploadEquipmentImgList;
                noUploadEquipmentImgList.splice(i, 1)
                this.setState({
                    noUploadEquipmentImgList
                })
            }
        }

    };

    dele = () => {

    }

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async (page = 1) => {
        await this.setState({ page, data_loading: true })
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            status: this.state.status,
        }
        let { flag, data, msg, total } = await app.post(api.PrepAuditlists, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setState({
                data: data,
                total: parseInt(total || 0),
            })
        }
    }

    // 页面渲染区
    render() {
        let { data, searcWhitehList, total, page, up_loading } = this.state
        const columns = [
            {
                title: '申请编号',
                width: 200,
                dataIndex: 'apply_no',
                key: 'apply_no',
            },
            {
                title: '申请名称',
                width: 200,
                dataIndex: 'teamname',
                key: 'teamname',
            },
            {
                title: '申请人',
                dataIndex: 'name',
                key: 'name',
                width: 200,

            },
            {
                title: '申请类别',
                dataIndex: 'type',
                key: 'type',
                width: 100,

            },
            {
                title: '申请时间',
                dataIndex: 'created_at',
                key: 'created_at',
                width: 200,

            },
            {
                title: '督导官审核',
                // dataIndex: 'audit_title',
                // key: 'audit_title',
                width: 200,
                render: (record) => <div>
                    {/* {
                        console.log(record)
                    } */}
                    <p>{record.one_vname}</p>
                    <p>{record.one_audit_title}

                        <Popover content={record.detail} >
                            <span style={{ color: '#1890ff' }}>{record.one_audit_title == '审核不通过' ? '查看原因' : ''}</span>
                        </Popover>
                    </p>
                    <p>{record.one_time}</p>
                </div>

            },
            {
                title: '二级审核',
                // dataIndex: 'audit_title',
                // key: 'audit_title',
                width: 200,
                render: (record) => <div>

                    <p>{record.two_vname}</p>
                    <p>{record.two_audit_title}
                    </p>
                    <p>{record.two_time}</p>
                </div>

            },
            {
                title: '操作',
                key: 'operation',
                width: 200,
                height: 200,
                render: (record) => <div>
                    <div >
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.Details(record)}>详情</Button>
                    </div>
                    {
                        record.audit_level == 2 || record.one_audit == 2 || this.state.status == 1
                            ? ''
                            : <div style={{ marginTop: 7 }}>
                                <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.goExamine(record)}>前往审核</Button>
                            </div>
                    }


                </div>,
            },
        ];

        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        }

        // 白名单
        const whiteList = [
            {
                title: '姓名',
                width: 200,
                dataIndex: 'vname',
                key: 'vname',
            },
            {
                title: '所属队伍',
                width: 200,
                dataIndex: 'teamname',
                key: 'teamname',
            },
            {
                title: '职位',
                dataIndex: 'teamposition',
                key: 'teamposition',
                width: 200,
            },
            {
                title: '操作',
                key: 'operation',
                width: 300,
                height: 200,
                render: (record) => <div>

                    <div style={{ marginTop: 7 }}>
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff', width: 80, height: 30 }} onClick={() => this.deleWhite(record)}>删除</Button>
                    </div>

                </div>,
            },
        ];

        const myApplication = (
            <div style={{ marginTop: 20 }}>
                {/* 列表 */}
                <div>
                    <Table columns={columns} dataSource={data} 
                    // scroll={{y: 'calc(100% - 103px)'}}
                    // style={{height: '80%'}}
                        pagination={false}
                        footer={() => {
                            return (
                                <Row hidden={data.length === 0}>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Pagination total={total} size="small" pageSize={20} current={page}
                                            showTotal={(total) => `总数量：${total}`}
                                            onChange={this.dataSource} />
                                    </Col>
                                </Row>
                            )
                        }}
                        size="small" />
                </div>

            </div>
        )

        const OKmodal = (


            <div>
                {
                    this.state.examineInfo.audit_level == 1
                        ?
                        //如果已经完成了一级审核
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', }}>

                                <div style={{ width: 80 }}>
                                    <span style={{ color: 'red' }}>*</span>
                                对筹备组通过备案作出评价：
                            </div>
                                <div>
                                    <textarea name="" id="" rows="10" style={{ height: '100%', width: 500, resize: 'none', borderRadius: 10 }} onChange={this.getReasonTitle} name="twoReasonTitle"></textarea>
                                </div>
                            </div>

                            <p style={{ color: '#fb6519', textAlign: 'center' }}>对筹备组备案是否通过作出评价，通过平台公开评价内容</p>


                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.okUpload} >提交</Button>
                                <Button style={{ width: 200 }} onClick={this.downExamine}>关闭</Button>
                            </div>

                        </div>

                        :
                        //没有完成一级审核
                        <div>
                            <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                <span style={{ color: 'red' }}>*</span>
                            场地核查情况：
                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                        <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                            {
                                                this.state.okUploadFieldImgList.length >= 1 ? this.state.okUploadFieldImgList.map((i, v) => {
                                                    return (
                                                        <Popover content={
                                                            <div >
                                                                <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={i} data-state={'fieldImg'}>预览</p>
                                                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(v, 'fieldImg')} >删除</p>

                                                            </div>
                                                        }>

                                                            <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                        </Popover>

                                                    )
                                                })
                                                    : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                            }


                                        </div>
                                    </div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF', width: 130, height: 30, paddingTop: 30 }} >
                                        <Upload
                                            accept='image/jpeg, image/jpg, image/png'
                                            showUploadList={false}
                                            action={config.serverUrl + "/TeamApply/imageUpload"}
                                            name="image"
                                            onChange={this.okUploadFieldImg}
                                            style={{ color: '#1890FF' }} disabled={this.state.okUploadFieldImgList.length == 5}>上传照片</Upload>
                                    </div>

                                </div>



                            </div>

                            {/* 装备核查情况 */}
                            <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                <span style={{ color: 'red' }}>*</span>
                            装备核查情况：
                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                        <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                            {
                                                this.state.okUploadEquipmentImgList.length >= 1 ? this.state.okUploadEquipmentImgList.map((i, v) => {
                                                    return (
                                                        <Popover content={
                                                            <div >
                                                                <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={i} data-state={'quipmentImg'}>预览</p>
                                                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(v, 'quipmentImg')} >删除</p>
                                                            </div>
                                                        }>

                                                            <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                        </Popover>

                                                    )
                                                })
                                                    : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                            }
                                        </div>
                                    </div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF', width: 130, height: 30, paddingTop: 30 }} >
                                        <Upload
                                            accept='image/jpeg, image/jpg, image/png'
                                            showUploadList={false}
                                            action={config.serverUrl + "/TeamApply/imageUpload"}
                                            name="image"
                                            onChange={this.okUploadEquipmentImg}
                                            style={{ color: '#1890FF' }} disabled={this.state.okUploadEquipmentImgList.length == 5}>上传照片</Upload>
                                    </div>

                                </div>



                            </div>



                            <p style={{ color: 'red', textAlign: 'center' }}>由品牌督导官进行场地及装备核查，请上传真实的核查照片；</p>
                            <p style={{ color: 'red', textAlign: 'center' }}>场地核查情况、装备核查情况分别最多可上传5张照片，每张照片不可大于3M</p>

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.okUpload} >提交</Button>
                                <Button style={{ width: 200 }} onClick={this.downExamine}>关闭</Button>
                            </div>
                        </div>

                }

            </div>

        )





        const NOmodal = (

            <div>
                {
                    this.state.examineInfo.audit_level == 1
                        ?
                        // 2级审核不通过
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', }}>

                                <div style={{ width: 80 }}>
                                    <span style={{ color: 'red' }}>*</span>
                            对筹备组不通过备案作出评价：
                        </div>
                                <div>
                                    <textarea name="" id="" rows="10" style={{ height: '100%', width: 500, resize: 'none', borderRadius: 10 }} onChange={this.getReasonTitle} name="twoNoReasonTitle"></textarea>
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ width: 80 }}>
                                    <span style={{ color: 'red' }}>*</span>
                                    审核不通过原因：
                                </div>
                                <div>
                                    <textarea name="" id="" rows="10" style={{ height: '100%', width: 500, resize: 'none', borderRadius: 10 }} onChange={this.getReasonTitle} name="reasonTitle"></textarea>
                                </div>
                            </div>
                            <p style={{ color: '#fb6519', textAlign: 'center' }}>对筹备组备案是否通过作出评价，通过平台公开评价内容</p>
                        </div>
                        :
                        // 1级审核不通过
                        <div>
                            <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                场地核查情况：
                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>
                                        <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                            {
                                                this.state.noUploadFieldImgList.length >= 1 ? this.state.noUploadFieldImgList.map((i, v) => {
                                                    return (
                                                        <Popover content={
                                                            <div >
                                                                <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={i} data-state={'fieldImg'}>预览</p>
                                                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(v, 'fieldImg')}>删除</p>
                                                            </div>
                                                        }>

                                                            <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                        </Popover>

                                                    )
                                                })
                                                    : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                            }

                                        </div>
                                    </div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF', width: 130, height: 30, paddingTop: 30 }} >
                                        <Upload
                                            accept='image/jpeg, image/jpg, image/png'
                                            showUploadList={false}
                                            action={config.serverUrl + "/TeamApply/imageUpload"}
                                            name="image"
                                            onChange={this.noUploadFieldImg}
                                            style={{ color: '#1890FF' }} disabled={this.state.noUploadFieldImgList.length == 5}>上传</Upload>
                                    </div>

                                </div>



                            </div>


                            <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                装备核查情况：
                            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                        <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                            {
                                                this.state.noUploadEquipmentImgList.length >= 1 ? this.state.noUploadEquipmentImgList.map((i, v) => {
                                                    return (
                                                        <Popover content={
                                                            <div >
                                                                <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={i} data-state={'quipmentImg'}>预览</p>
                                                                <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(v, 'quipmentImg')}>删除</p>
                                                            </div>
                                                        }>

                                                            <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                        </Popover>

                                                    )
                                                })
                                                    : <img style={{ width: 90, height: 100, margin: 2 }} alt="" />
                                            }

                                        </div>
                                    </div>
                                    <div style={{ marginTop: 5, cursor: 'pointer', color: '#1890FF', width: 130, height: 30, paddingTop: 30 }} >
                                        <Upload
                                            accept='image/jpeg, image/jpg, image/png'
                                            showUploadList={false}
                                            action={config.serverUrl + "/TeamApply/imageUpload"}
                                            name="image"
                                            onChange={this.noUploadEquipmentImg}
                                            style={{ color: '#1890FF' }} disabled={this.state.noUploadFieldImgList.length == 5}>上传</Upload>
                                    </div>

                                </div>



                            </div>


                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                    <span style={{ color: 'red' }}>*</span>
                        审核不通过原因：
                    </div>
                                <div>
                                    <textarea name="" id="" rows="10" style={{ height: '100%', width: 500, resize: 'none', borderRadius: 10 }} onChange={this.getReasonTitle} name="reasonTitle"></textarea>
                                </div>
                            </div>


                            <p style={{ color: 'red', textAlign: 'center' }}>由品牌督导官进行场地及装备核查，请上传真实的核查照片；</p>
                            <p style={{ color: 'red', textAlign: 'center' }}>场地核查情况、装备核查情况分别最多可上传5张照片，每张照片不可大于3M</p>


                        </div>
                }
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button style={{ width: 200, backgroundColor: '#1890FF', color: '#fff', marginRight: 40 }} onClick={this.noUpload}>提交</Button>
                    <Button style={{ width: 200 }} onClick={this.downExamine}>关闭</Button>
                </div>

            </div>

        )


        // const imgList = (this.state.examineInfo.mall_img.split(';;;')).map((item, index) => {
        //     return (
        //         <Popover content={
        //             <div >
        //                 <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={item}>预览</p>
        //                 <p style={{ cursor: 'pointer' }} onClick={() => this.deleImg(index)}>删除</p>


        //             </div>
        //         }>

        //             <img style={{ width: 90, height: 100, margin: 2 }} key={item} src={config.imgUrl + item} alt="" />
        //         </Popover>

        //     )
        // })






        return (
            <div >

                <div style={{ display: 'flex' }}>
                    <div>
                        审核状态：
    <Select placeholder="请选择" style={{ width: 150 }} onSelect={(e) => this.choiceOption(e)} defaultValue="未审核">
                            <Option value="1" >未审核</Option>
                            <Option value="2">已审核</Option>
                        </Select>
                    </div>


                    <div style={{ paddingLeft: 50 }}>
                        {/* 审核状态： */}
                        <Select placeholder="请选择" style={{ width: 100 }} onSelect={(e) => this.choiceOption2(e)} defaultValue="队伍名称">
                            <Option value="teamname">队伍名称</Option>
                            {/* <Option value="apply_no">队伍编号</Option> */}
                        </Select>

                        <AutoComplete
                            style={{ height: 50, width: 200 }}
                            // dataSource={memberList}
                            filterOption={(inputValue, option) =>
                                option.props.children.includes(inputValue)
                            }
                            onChange={this.getInputValue}
                            placeholder="输入关键词搜索"
                        />
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.clickSearch}>搜索</Button>
                    </div>


                    <div style={{ paddingLeft: 50 }} hidden={app.getData('rights') != 1}>
                        {/* 审核状态： */}
                        <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.openWhiteListModal}>白名单</Button>
                    </div>
                </div>



                <div>
                    {myApplication}
                </div>



                {/* 详情展示 */}
                <Modal title={this.state.modalInfo.length < 1 ? '' : this.state.modalInfo.teamname} visible={this.state.EditorFlag} width={'95%'} footer={null} onCancel={this.EditorModalCencel}>
                    <Editor
                        goExamine={this.goExamine}
                        modalInfo={this.state.modalInfo}
                        examine={1}
                        examineInfo={this.state.examineInfo}
                        audit_level={this.state.audit_level}
                        EditorModalCencel={this.EditorModalCencel} />
                </Modal>
                {/* 详情展示 */}








                {/* 审核窗口 */}
                <Modal title="审核窗口" visible={this.state.examineModel} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.downExamine}>



                    {/* {
        console.log(this.state.modalInfo)
    } */}
                    <div>
                        {
                            this.state.modalInfo.audit_level == 1
                                ?
                                // 如果审核了一级之后
                                // 以下展示的一级审核信息详情
                                <div>
                                    <div>
                                        审核状态：<span style={{ color: '#00a9ff' }}>{this.state.modalInfo.one_audit_title}</span>
                                    </div>

                                    <div style={{ paddingTop: 30 }}>
                                        审核人姓名：<span >{this.state.modalInfo.one_indexno}</span>
                                    </div>

                                    <div style={{ paddingTop: 30 }}>
                                        审核人时间：<span >{this.state.modalInfo.one_time}</span>
                                    </div>


                                    <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                        场地核查情况：
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                                <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                    {console.log(this.state.examineInfo.place_img.split(';;;'))}
                                                    {
                                                        this.state.examineInfo.place_img != '' ? (this.state.examineInfo.place_img.split(';;;')).map((i, v) => {
                                                            return (
                                                                <Popover content={
                                                                    <div >
                                                                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={i} data-type={'examine'} data-state={'fieldImg'}>预览</p>
                                                                    </div>
                                                                }>

                                                                    <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                                </Popover>

                                                            )
                                                        })
                                                            : '无'
                                                    }

                                                </div>
                                            </div>


                                        </div>



                                    </div>

                                    <div style={{ height: 150, display: 'flex', alignItems: 'center' }}>
                                        装备核查情况：
                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-around', width: 300 }}>

                                                <div style={{ cursor: 'pointer', overflowX: 'auto', whiteSpace: 'nowrap', padding: 3, width: 300 }}>
                                                    {
                                                        this.state.examineInfo.mall_img != '' ? (this.state.examineInfo.mall_img.split(';;;')).map((i, v) => {
                                                            return (
                                                                <Popover content={
                                                                    <div >
                                                                        <p style={{ marginBottom: 20, cursor: 'pointer' }} onClick={this.clickImg} data-img={i} data-type={'examine'} data-state={'quipmentImg'}>预览</p>
                                                                    </div>
                                                                }>

                                                                    <img style={{ width: 90, height: 100, margin: 2 }} alt="" src={config.imgUrl + i} />
                                                                </Popover>

                                                            )
                                                        })
                                                            : '无'
                                                    }
                                                </div>
                                            </div>


                                        </div>



                                    </div>

                                    <div hidden={this.state.examineInfo.one_audit != 2}>
                                        审核不通过原因：{this.state.examineInfo.detail}
                                    </div>


                                </div> : ''
                        }
                    </div>





                    <Spin spinning={up_loading} tip={'图片上传中'}>

                        <div style={{ width: 1200, paddingTop: 3 }}>
                            {/* 审核操作 */}
                            <div style={{ height: 40, paddingTop: 20 }}>
                                <span style={{ color: 'red' }}>*</span>
            审核操作：
            <RadioGroup options={[
                                    { label: '通过', value: 'OK' },
                                    { label: '不通过', value: 'NO' },
                                ]}
                                    value={this.state.examineRadio}
                                    onChange={this.examineRadio} />

                            </div>
                            {/* 场地审核情况 */}
                            <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                                {this.state.examineRadio == '' ? '' : (this.state.examineRadio == 'OK' ? OKmodal : NOmodal)}
                            </div>

                        </div>
                    </Spin>

                </Modal>



                {/* 二级审核窗口 */}
                {/* <Modal title="审核窗口" visible={this.state.examineModel2} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.downExamine2}>






    <div style={{ width: 1200, paddingTop: 3 }}>
        <div style={{ height: 40, paddingTop: 3 }}>
            <span style={{ color: 'red' }}>*</span>
            审核操作：
            <RadioGroup options={[
                { label: '通过', value: 'OK' },
                { label: '不通过', value: 'NO' },
            ]}
                value={this.state.examineRadio}
                onChange={this.examineRadio} />

        </div>

        {this.state.examineRadio == 'OK' ? OKmodal : NOmodal}
    </div>

</Modal> */}



                {/* 白名单窗口 */}
                <Modal title="添加白名单" visible={this.state.WhiteListModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.closeWhiteList}>
                    <div style={{ paddingLeft: 50, paddingBottom: 50 }}>
                        <Search placeholder="搜索" onSearch={this.onSearch} onChange={this.getInput} enterButton style={{ width: 600, marginRight: 100 }} />

                        <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.addWhiteList}>添加审核人员</Button>
                    </div>
                    <div>
                        <Table columns={whiteList} dataSource={this.state.whiteInfoList} scroll={{ x: 900, y: 300 }} />
                    </div>

                </Modal>


                <Modal title="添加白名单" visible={this.state.addWhiteListModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.closeaddWhiteListModal}>
                    <Select placeholder="请选择" style={{ width: 100 }} onSelect={(e) => this.whiteSele(e)} defaultValue="searchform_name">
                        <Option value="searchform_name">名称</Option>
                        <Option value="searchform_code">编号</Option>
                    </Select>

                    <AutoComplete
                        style={{ height: 50, width: 200 }}
                        dataSource={searcWhitehList}
                        filterOption={(inputValue, option) =>
                            // let inputValue = {}
                            option.props.children.includes(inputValue,option)
                            
                        }
                        onChange={this.add}
                        placeholder="输入关键词搜索"
                    />
                    <Button style={{ backgroundColor: '#1890FF', color: '#fff' }} onClick={this.addWhite}>添加</Button>
                </Modal>



                {/* 图片展示 */}
                <Modal title="" visible={this.state.imgModal} width={1200} style={{ display: 'flex', justifyContent: 'center' }} footer={null} onCancel={this.clickImgCencel}>
                    <p style={{ display: 'flex', justifyContent: 'space-around', color: '#1890ff', fontWeight: 'bold' }}>
                        <div style={{ cursor: 'pointer' }} onClick={this.lastImg}>
                            <Icon type="left" ></Icon> 上一张
                    </div>
                        <div style={{ cursor: 'pointer' }} onClick={this.nextImg}>
                            下一张<Icon type="right" ></Icon>
                        </div>
                    </p>
                    {

                        <img src={config.imgUrl + this.state.showMoadlImg} alt="" style={{ width: 1000 }} />
                    }
                </Modal>


            </div>


        )
    }
}



export default ReTeamApplicationAuditCom



// WEBPACK FOOTER //
// ./src/routes/review/ReTeamApplicationAudit/ReTeamApplicationAuditCom.jsx